// extracted by mini-css-extract-plugin
export var actionButton = "_kv-t";
export var buttonContainer = "_kv-0";
export var buttonContainer2 = "_kv-1";
export var buttonSection = "_kv-2";
export var details = "_kv-3";
export var dropdownItem = "_kv-5";
export var dropdownItemsContainer = "_kv-4";
export var fileInput = "_kv-r";
export var headerButton = "_kv-6";
export var icon = "_kv-7";
export var input = "_kv-8";
export var macroListItem = "_kv-9";
export var mainContent = "_kv-a";
export var microText = "_kv-b";
export var modal = "_kv-w";
export var optionsButton = "_kv-c";
export var paperclip = "_kv-s";
export var pillContent = "_kv-d";
export var preview = "_kv-e";
export var preview2 = "_kv-f";
export var quillEditor = "_kv-q";
export var selectedMacro = "_kv-g";
export var sidebar = "_kv-h";
export var sidebarHeader = "_kv-j";
export var sidebarList = "_kv-i";
export var sidebarListItem = "_kv-k";
export var sidebarSearch = "_kv-l";
export var snoozeDurationWrapper = "_kv-v";
export var statusPillContainer = "_kv-m";
export var tagsContainer = "_kv-n";
export var unselectedMacro = "_kv-o";
export var variable = "_kv-u";
export var wrapper = "_kv-p";